import script from "./TicPatientStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./TicPatientStrip.vue?vue&type=script&setup=true&lang=js"

import "./TicPatientStrip.vue?vue&type=style&index=0&id=2685611c&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2685611c"]])

export default __exports__